import { createFileRoute } from '@tanstack/react-router'
import { CasesPage } from '@/features/cases'

/** The cases list at `/cases` — the index child of the Cases layout route. */
export const Route = createFileRoute('/_auth/cases/')({
  component: CasesPage,
})
